import React, {useState} from "react";
import AsyncSelect from 'react-select/async';

export const CampoSelectAsync = ({
    disabled,
    blank,
    name,
    isMulti,
    selectedValue,
    placeholder,
    onChange,
    remoteCall,
    fieldShow,
    fieldShowSecond,
    errors = {},
    touched = {},
  }) => {
    const [loading, setLoading] = useState(false);
    const valorDefault = () => {
      if (selectedValue === undefined) return undefined;
      return selectedValue;
    };
    const handleChange = (value) => {
      onChange(name, value);
    };
    const loadOptions = async (inputValue) => {
      if (inputValue === undefined) return [];
      setLoading(true);
      const results = await remoteCall(inputValue);
      setLoading(false);
      if (results === null) return [];
      return results.results.map((x) => {
        if (fieldShowSecond !== undefined)
          return {
            label: `${x[fieldShow]} ${x[fieldShowSecond]}`.toUpperCase(),
            original_value: x,
            value: x.id,
          };
        return { label: x[fieldShow].toUpperCase(), value: x.id, original_value: x };
      });
    };
    const loadMulti = () => {
      if (isMulti === undefined) return false;
      return isMulti;
    };
    return (
      <>
        <AsyncSelect
          defaultOptions
          onChange={handleChange}
          name={name}
          isDisabled={disabled}
          isLoading={loading}
          isClearable={blank}
          isMulti={loadMulti()}
          isSearchable
          defaultValue={valorDefault()}
          value={selectedValue}
          loadOptions={loadOptions}
          placeholder={placeholder}
        />
        {errors[name] && touched[name] && (
          <label
            style={{
              color: '#FFFFF',
            }}
          >
            {errors[name]}
          </label>
        )}
      </>
    );
  };